import type { ReactNode } from 'react';

/**
 * **Le bandeau — le SEUL endroit du produit où un fond teinté existe.**
 *
 * `DESIGN.md` : « **le fond teinté ne descend jamais dans une ligne de liste.** Il ne sert
 * que sous un bandeau, **qui est un bloc entier portant une phrase**. » Un bandeau qui
 * porterait une liste, un tableau ou des boutons cesserait d'être ce que la charte
 * autorise.
 */
type Ton = 'attention' | 'echec' | 'accent' | 'positif';

const PAR_TON: Record<Ton, string> = {
  attention: 'bg-bandeau-attention-fond text-bandeau-attention-texte',
  echec: 'bg-bandeau-echec-fond text-bandeau-echec-texte',
  accent: 'bg-bandeau-accent-fond text-bandeau-accent-texte',
  positif: 'bg-bandeau-positif-fond text-bandeau-positif-texte',
};

type Props = {
  readonly ton: Ton;
  readonly children: ReactNode;
  /** Une action unique, à droite. Deux feraient du bandeau une barre d'outils. */
  readonly action?: ReactNode;
};

export function Bandeau({ ton, children, action }: Props) {
  return (
    <div
      role={ton === 'echec' ? 'alert' : 'status'}
      className={[
        'flex items-center justify-between gap-4',
        'rounded-3 px-4 py-3 text-14 leading-normal',
        PAR_TON[ton],
      ].join(' ')}
    >
      <p className="font-weight-500">{children}</p>
      {action}
    </div>
  );
}
